import agent from '../../api/agent'
import { defAction } from "../../helpers/defaultAction"
import history from "../../helpers/history"
import { userConstants } from "../constants/user"

export const userActions = {
	login,
	logout,
	refreshUserData
}

function login(values, navigate) {
	const dispatchObj = {
		constants: userConstants.Login,
		service: {
			func: agent.User.login,
			params: values
		},
		sucFunction: () => {
			// if (navigate)
			// 	navigate('/account')
			// else
			// 	history.push('/account')
		}
	}

	return defAction(dispatchObj)
}

function logout(navigate) {
	const dispatchObj = {
		constants: userConstants.Logout,
		sucFunction: () => {
			if (navigate)
				navigate('/')
			else
				history.push('/')
		}
	}

	return defAction(dispatchObj)
}

function refreshUserData(values) {
	const dispatchObj = {
		constants: userConstants.RefreshUserData,
		service: {
			func: agent.User.refreshUserData,
			params: values
		}
	}

	return defAction(dispatchObj)
}